import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CategoryTemplatePage } from './category-template.page';

const routes: Routes = [
  {
    path: '',
    component: CategoryTemplatePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CategoryTemplatePageRoutingModule {}
